<script lang="ts">
  import FooterLinkSubcomponent from '../FooterLinkSubcomponent/FooterLinkSubcomponent.svelte';

  export let isSubcategory = false;
  let isFolded = true;

  const navItems = $$props.navigationItems.filter(
    (item: ComponentContent) => item.componentName === 'FooterLinkSubcomponent'
  );
  const subcategories = $$props.navigationItems.filter(
    (item: ComponentContent) => item.componentName === 'FooterCategorySubcomponent'
  );
</script>

<div
  class="FooterCategorySubcomponent"
  class:FooterCategorySubcomponent--subcategory={isSubcategory}
  class:hidden={$$props.hidden}
  data-entry-id={$$props.id}
>
  <!-- Interactive heading that shows only on mobile -->
  <button
    class="category-heading--button"
    on:click={() => {
      isFolded = !isFolded;
    }}
  >
    <h6 class="caret" class:caret-flipped={!isFolded}>{$$props.title}</h6>
  </button>

  <!-- Static heading that shows above mobile breakpoint -->
  <h6 class="category-heading">{$$props.title}</h6>

  <div class="navLinks" class:folded={isFolded}>
    <ul class="navLinksList">
      {#each navItems as item}
        <FooterLinkSubcomponent id={item.contentfulEntryId} locale={item.locale} {...item.props} />
      {/each}
    </ul>
  </div>

  {#if subcategories}
    {#each subcategories as subcategory}
      <svelte:self id={subcategory.contentfulEntryId} isSubcategory={true} {...subcategory.props} />
    {/each}
  {/if}
</div>

<style lang="scss">
  @use '@squareup/public-web-design-system/dist/styles/xms-fe/mixins/grid.scss' as grid;

  @layer standard-components {
    $SMALL_BREAKPOINT: 480px;

    button {
      border: none;
      background: none;
      color: inherit;
      cursor: pointer;
    }

    h6 {
      font-size: var(--font-size-16);
      margin-top: 0;
      margin-bottom: var(--space-10);
      color: var(--color-gray-55);
    }

    .category-heading {
      display: none;
      @media (min-width: $SMALL_BREAKPOINT) {
        display: block;
      }
    }

    .category-heading--button {
      display: inline-block;
      @media (min-width: $SMALL_BREAKPOINT) {
        display: none;
      }
    }

    .caret {
      position: relative;

      // @include media.until('small') {
      @media (max-width: ($SMALL_BREAKPOINT - 1px)) {
        &::after {
          content: '›';
          pointer-events: none;
          display: inline-block;
          margin-left: 0.5em;
          transition: transform var(--duration-quick) var(--easing-sharp);
          transform: rotate(90deg);
        }

        &.caret-flipped::after {
          transform: translateX(-0.1875em) rotate(-90deg);
        }
      }
    }

    .navLinks {
      padding-bottom: var(--space-30);
    }

    .navLinksList {
      @include grid.columns(1);
      @include grid.space-row(10);
      @include grid.space-col(30);
    }

    .folded {
      height: auto;
      opacity: 1;
      overflow: visible;

      @media (max-width: ($SMALL_BREAKPOINT - 1px)) {
        overflow: hidden;
        height: 0;
        opacity: 0;
        padding-bottom: 0;
      }
    }
  }
</style>
